'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { toAnalyticsReasonCode, trackWalletAction } from '@workspace/analytics/posthog/events';
import { Button } from '@workspace/ui/components/button';
import { AlertDialog } from '@workspace/ui/components/custom/alert-dialog';
import { toast } from 'sonner';
import { useCancelTransaction } from '@/hooks/use-transactions';

interface CancelTransactionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess: () => void;
  transactionId?: number;
}

export function CancelTransactionDialog({
  open,
  onOpenChange,
  onSuccess,
  transactionId,
}: CancelTransactionDialogProps) {
  const cancelTransactionMutation = useCancelTransaction();

  const handleCancel = async () => {
    if (!transactionId) {
      toast.error('Transaction information is missing. Please try again.');
      return;
    }

    try {
      await cancelTransactionMutation.mutateAsync(transactionId);
      trackWalletAction('transaction_cancelled', { flow: 'transaction', result: 'success' });

      // Close this dialog and call the onSuccess callback (for showing success dialog)
      onOpenChange(false);
      onSuccess();
    } catch (error) {
      trackWalletAction('transaction_cancelled', {
        flow: 'transaction',
        result: 'failure',
        ...(error instanceof Error ? { reason_code: toAnalyticsReasonCode(error) } : {}),
      });
      console.error('Transaction cancellation failed:', error);
      toast.error(
        error instanceof Error ? error.message : 'Failed to cancel transaction. Please try again.'
      );
    }
  };

  return (
    <AlertDialog
      open={open}
      onOpenChange={onOpenChange}
      variant="error"
      title="Cancel top-up?"
      description="If you've already made a bank transfer, please contact us after cancellation to proceed with the refund."
    >
      <Button
        variant="destructive"
        className="w-full"
        onClick={handleCancel}
        isLoading={cancelTransactionMutation.isPending}
        loadingText={'Cancelling top-up'}
      >
        Cancel top-up
      </Button>
      <Button variant="secondary" className="w-full" onClick={() => onOpenChange(false)}>
        Close
      </Button>
    </AlertDialog>
  );
}
